// src/components/TarjetaProducto.jsx
import React from "react";
import { Link } from "react-router-dom";
import { useCart } from "../context/CartContext";

const TarjetaProducto = ({ id, nombre, descripcion, imagen, precio }) => {
  const { addToCart } = useCart();

  const handleAddToCart = () => {
    const producto = {
      id,
      nombre,
      descripcion,
      imagen,
      precio,     // <-- agregado
      cantidad: 1,
    };

    addToCart(producto); // se pasa el producto al contexto
  };

  return (
    <div className="border border-gray-200 rounded-lg overflow-hidden shadow-sm hover:shadow-md transition-shadow duration-200 flex flex-col">
      {/* Imagen */}
      <img src={imagen} alt={nombre} className="w-full h-56 object-cover" />

      {/* Contenido */}
      <div className="p-4 flex flex-col gap-3 flex-1">
        <h3 className="text-gray-900 font-semibold text-lg">{nombre}</h3>
        <p className="text-gray-600 text-sm flex-1">{descripcion}</p>
        <p className="text-gray-900 font-bold text-base">${precio}</p>

        <div className="flex gap-2">
          {/* Botón ver producto */}
          <Link
            to={`/producto/${id}`}
            className="flex-1 bg-gray-700 text-white text-sm font-medium py-2 px-4 rounded-lg text-center hover:bg-gray-800 transition"
          >
            Ver Producto
          </Link>

          {/* Botón agregar al carrito */}
          <button
            onClick={handleAddToCart}
            className="flex-1 bg-green-600 text-white text-sm font-medium py-2 px-4 rounded-lg hover:bg-green-700 transition"
          >
            Agregar
          </button>
        </div>
      </div>
    </div>
  );
};

export default TarjetaProducto;
